<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/kornatus_500-500.png" alt="Kornatus Admin" width="120" height="120">
                  <h1 class="flex my-4 primary--text">BanBanTaxi Admin</h1>
                </div>                
                <v-form>
                  <v-text-field append-icon="person" name="username" label="Login" id="username" type="text" v-model="model.username"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Password" id="password" type="password" v-model="model.password" @keyup.enter="login"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="login()" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    model: {
      username: '',
      password: '',
      msg: ''
    }
  }),

  methods: {
    login () {
      const id = this.model.username;
      const pw = this.model.password;

      if(!id || !pw) {
        window.getApp.$emit('APP_LOGIN_INVALID');
        return;
      }

      // LOGIN 액션 실행 
      this.$store.dispatch('LOGIN', { id, pw })
        .then(() => this.redirect())
        .catch((error) => {
          if (error.response.data.message === 'NOT_EXIST_USER') {
            window.getApp.$emit('APP_LOGIN_FAIL');
          }
        });
    },
    redirect () {

      // 리다이렉트 처리 
      this.$router.push('/call/realTimeCall');
    }
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue